import { includes } from '../typescript';
import { getLocales, type Locale, LOCALE_DEBUG, LOCALE_PSEUDO } from './constants';

type Pseudo = typeof LOCALE_DEBUG | typeof LOCALE_PSEUDO;

export const filterPseudo = <T extends string>(locale: T): locale is Exclude<T, Pseudo> => {
    return locale !== LOCALE_PSEUDO && locale !== LOCALE_DEBUG;
};

export const isLocale = (locale: unknown): locale is Locale => {
    return includes(getLocales(), locale);
};
